import { render } from "../templates/benefitCards.html?vue&type=template&id=64152da5"
import script from "./benefitCards.vue?vue&type=script&lang=js"
export * from "./benefitCards.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__